import React from 'react';
import menuConfig from '@/config/menu';
import AppLayout from '@/layouts/app-layout';
import withRouter from '@/components/organisms/withRouter';
import PageTitle from '@/components/molecules/PageTitle';
import TopPage from '@/pages/bfu/BFU50101G';

/**
 * デモページ (ダミーページ)
 */
class DemoPage extends React.Component {
  render() {
    const { location } = this.props;

    // メニュー項目検索
    const pagePath = location.pathname;
    const menuItem = menuConfig.root.find((item) => item.link === pagePath);
    const menuTitle = menuItem?.label;

    // メニュー項目がなければトップページを表示
    if (!menuTitle) {
      return <TopPage />;
    }

    // タイトルのみのダミーページを表示
    return (
      <AppLayout props={this.props}>
        <PageTitle pageTitle={menuTitle} />
      </AppLayout>
    );
  }
}
export default withRouter(DemoPage);
